import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardSidebar from './DashBoardSidebar';

const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('isAuthenticated');  

    // If not authenticated, redirect to login page
    if (!isAuthenticated || isAuthenticated === "false") {
      console.log('Not authenticated, redirecting...');
      navigate('/login');  // Ensure you redirect to the login page
    }
  }, [navigate]);

  return (
    <div className="dashboard">
      {/* Dashboard Sidebar */}
      <DashboardSidebar />
    </div>
  );
};

export default Dashboard;
